// assets
// ⚠ IconDiscount2 KULLANMAYIN. @tabler/icons-react 3.35's .d.ts'i onu HÂLÂ bildiriyor (eski sürüm
// takma adları tip dosyasında duruyor) ama ESM çalışma-zamanı paketi DIŞA AKTARMIYOR — yani
// `tsc --noEmit` temiz geçer ve tarayıcı "does not provide an export named 'IconDiscount2'" ile
// TÜM menüyü düşürür. Var olan adlar: IconDiscount / IconDiscountOff / IconDiscountFilled.
import {
  IconBuildingStore,
  IconCash,
  IconDiscount,
  IconReceipt2,
  IconReceiptRefund,
  IconShoppingCart,
  IconTags,
  IconTruckDelivery
} from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - COMMERCE (P3-1) ||============================== //

const commerce: NavItemType = {
  id: 'commerce',
  title: 'commerce', // react-intl key - i18n-ready [STD-DRIFT]
  icon: IconShoppingCart,
  type: 'group',
  requiredModule: 'commerce',
  children: [
    {
      id: 'commerce-pricing-rulesets',
      title: 'commerce-pricing-rulesets',
      icon: IconTags,
      type: 'item',
      url: '/commerce/pricing-rulesets',
      module: 'commerce.pricing_lists'
    },
    {
      id: 'commerce-products',
      title: 'commerce-products',
      icon: IconBuildingStore,
      type: 'item',
      url: '/commerce/products',
      module: 'commerce.products'
    },
    {
      id: 'commerce-orders',
      title: 'commerce-orders',
      icon: IconReceipt2,
      type: 'item',
      url: '/commerce/orders',
      module: 'commerce.orders'
    },
    {
      id: 'commerce-purchase',
      title: 'commerce-purchase',
      icon: IconTruckDelivery,
      type: 'item',
      url: '/commerce/purchase',
      module: 'commerce.purchase'
    },
    {
      // OFR-APR (mig 342): iş ortaklarının fiyat teklifleri ve onay kuyruğu. Veri `event`
      // şemasındadır ve uç /api/v1/engagement/event-offers'tır — teklif bir BİLET fiyatıdır, bilet
      // ve koltuk Engagement'ın. Burada olması gruplamadır (satış/finans bu ekranda çalışır), bu
      // yüzden module gate'i engagement.event_offers'tır, commerce.* DEĞİL — Tanımlar'daki taksit
      // seçenekleriyle aynı ayrım, ters yönde.
      id: 'commerce-offers',
      title: 'commerce-offers',
      icon: IconDiscount,
      type: 'item',
      url: '/commerce/offers',
      module: 'engagement.event_offers'
    },
    {
      // DISC-CODE (migs 440/441/442): indirim kodu KATALOĞU — "hangi indirimler var olabilir".
      //
      // ⚠ `module:` DEĞİL `permission:`. Modül kapısı "discounts üzerinde HERHANGİ bir yetki" demektir
      // ve bu modülün en dar yetkisi .grant'tir — yani yalnız kod DAĞITABİLEN bir kayıt görevlisi
      // katalog ekranını görür ve her satırda 403 alır. Katalog .view'ün işidir; mig 441 ikisini
      // bilerek ayırdı (kampanyayı tasarlayan ile masada oturan aynı kişi değil), menü de onu izler.
      // Aynı ayrım commerce-payment-approvals'ta da var, aynı gerekçeyle.
      id: 'commerce-discounts',
      title: 'commerce-discounts',
      icon: IconDiscount,
      type: 'item',
      url: '/commerce/discounts',
      permission: 'commerce.discounts.view'
    },
    {
      // CASH (migs 349/350): kasalar — para TOPLAMA NOKTALARI ana verisi (bakiye/defter YOK).
      // Tablo commerce şemasındadır ve öyle kalmalıdır: ileride bir çevrimdışı tahsilat kasaya
      // bağlanırsa FK ŞEMA-İÇİ olur. Billing'de olsaydı yasak bir cross-schema okuma olurdu.
      id: 'commerce-cash-registers',
      title: 'commerce-cash-registers',
      icon: IconCash,
      type: 'item',
      url: '/commerce/cash-registers',
      module: 'commerce.cash_registers'
    },
    {
      // PAY-DOC (migs 356/357): havale/EFT dekontlarının onay kuyruğu.
      //
      // ⚠ `module:` DEĞİL `permission:`. Modül kapısı "installments üzerinde HERHANGİ bir yetki"
      // demektir, yani yalnız .view taşıyan biri kuyruğu görür ve her satırda 403 alır. Onaylamak
      // ayrı ve DAR bir yetkidir (mig 357, .update'ten bilinçle ayrıldı), menü de onu izler.
      // DOC-ISS2: Belge Düzenleyen AYARLAR menüsüne taşındı (settings.ts). Veri hâlâ Commerce'in ve
      // yetki hâlâ commerce.documents.issuer_profile — değişen tek şey insanın nereye baktığı.
      id: 'commerce-payment-approvals',
      title: 'commerce-payment-approvals',
      icon: IconReceiptRefund,
      type: 'item',
      url: '/commerce/payment-approvals',
      permission: 'commerce.installments.approve'
    }
  ]
};

export default commerce;
